export type FunnelAttribution = {
  source_page?: string | null;
  source_section?: string | null;
  source_cta?: string | null;
  product_key?: string | null;
  intent?: string | null;
  currency?: string | null;
  checkout_mode?: string | null;
};

function normalizeValue(value: string | null | undefined) {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function appendRelativeQuery(
  href: string,
  params: Record<string, string | null | undefined>,
) {
  if (!href.startsWith("/")) return href;

  const url = new URL(href, "https://singingattitude.com");
  for (const [key, value] of Object.entries(params)) {
    const normalized = normalizeValue(value);
    if (normalized) {
      url.searchParams.set(key, normalized);
    }
  }

  return `${url.pathname}${url.search}${url.hash}`;
}

export function getFunnelAttributionFromSearchParams(
  searchParams: Record<string, string | undefined | null>,
): FunnelAttribution {
  return {
    source_page: normalizeValue(searchParams.source_page),
    source_section: normalizeValue(searchParams.source_section),
    source_cta: normalizeValue(searchParams.source_cta),
    product_key: normalizeValue(searchParams.product_key),
    intent: normalizeValue(searchParams.intent),
    currency: normalizeValue(searchParams.currency),
    checkout_mode: normalizeValue(searchParams.checkout_mode),
  };
}

export function toFunnelEventProperties(
  attribution: FunnelAttribution,
  extra?: Record<string, unknown>,
) {
  return {
    ...Object.fromEntries(
      Object.entries(attribution).filter(([, value]) => value != null && value !== ""),
    ),
    ...extra,
  };
}
